module.exports = __webpack_public_path__ + "img/9788954641449.76ed7426.jpg";